// import RepositoryFactory from "@/apis";
// const Testimonial = RepositoryFactory.testimonial;
import Testimonial from "../../apis/testimonial";

export default {
  createTestimonial({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Testimonial.createTestimonial(payload);
        // commit("CREATE_TESTIMONIAL", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getTestimonial({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Testimonial.getTestimonial(payload);
        commit("GET_TESTIMONIAL", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getAllTestimonial({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Testimonial.getAllTestimonial(payload);
        commit("GET_ALL_TESTIMONIAL", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateTestimonial({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Testimonial.updateTestimonial(payload);
        // commit("UPDATE_TESTIMONIAL", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteTestimonial({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Testimonial.deleteTestimonial(payload);
        // commit("DELETE_TESTIMONIAL", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
